import { LatestAnalysisDatestampProps, useLatestAnalysisDatestamp } from '@/components/NCCard/NCCard';

const useConservationLatestAnalysisDatestamp = (props?: LatestAnalysisDatestampProps) => {
  const hookProps = props ?? { date: '2024-10-01' };
  return useLatestAnalysisDatestamp(hookProps);
};

export { useConservationLatestAnalysisDatestamp as useLatestAnalysisDatestamp };
